var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScgcLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 95,
    viewBox: "0 15 300 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 300,
    height: 95
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M831.1,122.278a14.8,14.8,0,0,1-15.005-14.6v-.632a14.916,14.916,0,0,1,14.595-15.2h.712a15.072,15.072,0,0,1,11.555,4.536l-4.107,4.728a10.779,10.779,0,0,0-7.5-3.326c-4.929,0-8.488,4.123-8.488,9.154v.11c0,5.03,3.478,9.236,8.488,9.236,3.341,0,5.394-1.347,7.694-3.436L843.148,117a14.912,14.912,0,0,1-11.993,5.25",
    transform: "translate(-592.628 -66.587)",
    fill: "rgb(144, 102, 113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M711.788,122.258c-9.118,0-15.389-6.432-15.389-15.118v-.11a15.088,15.088,0,0,1,14.923-15.2h.383a16,16,0,0,1,11.583,4.041l-4.053,4.92a10.882,10.882,0,0,0-7.722-3c-4.71,0-8.406,4.151-8.406,9.154V107c0,5.388,3.669,9.318,8.872,9.318a10.409,10.409,0,0,0,6.079-1.759v-4.178h-6.517V104.8h12.705v12.782a18.877,18.877,0,0,1-12.514,4.645",
    transform: "translate(-505.709 -66.567)",
    fill: "rgb(144, 102, 113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M601.7,122.278a14.8,14.8,0,0,1-15.005-14.6v-.632a14.934,14.934,0,0,1,14.595-15.2H602a15.072,15.072,0,0,1,11.555,4.536l-4.107,4.728a10.779,10.779,0,0,0-7.5-3.326c-4.929,0-8.488,4.123-8.488,9.154v.11c0,5.03,3.478,9.236,8.488,9.236,3.341,0,5.394-1.347,7.694-3.436L613.748,117a14.912,14.912,0,0,1-11.993,5.25",
    transform: "translate(-426.043 -66.587)",
    fill: "rgb(144, 102, 113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M498.732,122.678A18.7,18.7,0,0,1,486.3,117.95l3.806-4.481a13.488,13.488,0,0,0,8.762,3.546c2.629,0,4.217-1.045,4.217-2.776v-.082c0-1.649-1.013-2.474-5.887-3.738-5.887-1.512-9.693-3.161-9.693-8.989v-.082c0-5.333,4.272-8.851,10.241-8.851a17.014,17.014,0,0,1,10.871,3.738l-3.341,4.865a13.656,13.656,0,0,0-7.585-2.941c-2.464,0-3.779,1.182-3.779,2.556v.082c0,1.924,1.26,2.556,6.3,3.876,5.887,1.539,9.283,3.683,9.283,8.824v.082c0,5.827-4.436,9.1-10.761,9.1",
    transform: "translate(-353.14 -67.069)",
    fill: "rgb(144, 102, 113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M490.489,253.767a6.229,6.229,0,0,1-4.189-1.594l1.287-1.539a4.505,4.505,0,0,0,2.957,1.182c.876,0,1.424-.357,1.424-.935,0-.55-.329-.825-2-1.264-2-.522-3.286-1.072-3.286-3.024,0-1.787,1.424-3,3.45-3a5.574,5.574,0,0,1,3.669,1.264l-1.177,1.649a4.877,4.877,0,0,0-2.574-.99c-.821,0-1.26.385-1.26.852,0,.66.411.852,2.136,1.292,2,.522,3.122,1.237,3.122,2.969,0,1.979-1.506,3.079-3.614,3.079",
    transform: "translate(-353.14 -176.636)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M527.863,253.8a4.993,4.993,0,0,1-5.066-4.92v-.165a5.03,5.03,0,0,1,4.929-5.14h.219a5.025,5.025,0,0,1,3.888,1.512l-1.4,1.539a3.637,3.637,0,0,0-2.519-1.127,2.94,2.94,0,0,0-2.875,3v.11a2.906,2.906,0,0,0,2.738,3.106h.11a3.5,3.5,0,0,0,2.6-1.182l1.369,1.4a5.087,5.087,0,0,1-4.053,1.787",
    transform: "translate(-379.643 -176.618)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M571.1,247.626c0-.935-.657-1.429-1.7-1.429h-2.163v2.859h2.191c1.068,0,1.67-.577,1.67-1.429m0,6.542-2.108-3.161h-1.7V254.2H565.1v-9.9h4.518c2.355,0,3.724,1.182,3.724,3.271a3.078,3.078,0,0,1-2.136,3.079l2.355,3.546Z",
    transform: "translate(-410.363 -177.147)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M604.8,254.024V244.1h7.475v1.952h-5.312v2.007h4.655v1.952h-4.655v2.062h5.367v1.952Z",
    transform: "translate(-439.192 -177.002)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M641.9,254.024V244.1h7.448v1.952h-5.285v2.007h4.655v1.952h-4.655v2.062h5.34v1.952Z",
    transform: "translate(-466.133 -177.002)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M685.928,254.024l-4.792-6.295v6.295H679V244.1h2l4.628,6.1v-6.1h2.136v9.923Z",
    transform: "translate(-493.074 -177.002)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M743.963,253.8a4.993,4.993,0,0,1-5.066-4.92v-.165a5.025,5.025,0,0,1,4.9-5.14h.247a5.025,5.025,0,0,1,3.888,1.512l-1.4,1.539a3.637,3.637,0,0,0-2.519-1.127,2.959,2.959,0,0,0-2.848,3.024v.137a2.906,2.906,0,0,0,2.738,3.106h.109a3.505,3.505,0,0,0,2.6-1.182l1.369,1.4a5.045,5.045,0,0,1-4.025,1.759",
    transform: "translate(-536.57 -176.618)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M793.463,318.6a4.993,4.993,0,0,1-5.066-4.92v-.165a5.03,5.03,0,0,1,4.929-5.14h.219a5.025,5.025,0,0,1,3.888,1.512l-1.4,1.594a3.637,3.637,0,0,0-2.519-1.127,2.94,2.94,0,0,0-2.875,3v.11a2.906,2.906,0,0,0,2.738,3.106h.11a3.505,3.505,0,0,0,2.6-1.182l1.369,1.4a5.087,5.087,0,0,1-4.053,1.787",
    transform: "translate(-572.516 -223.605)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M786.715,248.987a3.047,3.047,0,0,0-2.9-3.134h-.082a2.945,2.945,0,0,0-2.957,2.941v.137a3,3,0,0,0,2.875,3.106h.082a2.951,2.951,0,0,0,2.957-2.969c.027,0,.027-.055.027-.082M783.73,254.1a5.042,5.042,0,0,1-5.23-4.893v-.192a5.248,5.248,0,0,1,10.487,0,5.117,5.117,0,0,1-5.093,5.14h-.164",
    transform: "translate(-565.329 -176.913)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M834.222,254.024v-6.46l-2.793,4.233h-.055l-2.738-4.206v6.432H826.5V244.1h2.355l2.574,4.206,2.6-4.206h2.328v9.923Z",
    transform: "translate(-600.186 -177.002)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M879.413,247.564c0-.99-.657-1.512-1.752-1.512h-1.67v3.024h1.725a1.5,1.5,0,0,0,1.7-1.347Zm-1.78,3.464h-1.643V254H873.8v-9.9h4.053c2.355,0,3.779,1.4,3.779,3.436-.027,2.309-1.807,3.491-4,3.491",
    transform: "translate(-634.534 -177.002)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M917.415,248.987a3.047,3.047,0,0,0-2.9-3.134H914.4a2.945,2.945,0,0,0-2.957,2.941v.137a3.047,3.047,0,0,0,2.9,3.134h.082a2.986,2.986,0,0,0,2.985-2.941ZM914.43,254.1a5.042,5.042,0,0,1-5.23-4.893v-.192a5.248,5.248,0,0,1,10.487,0,5.123,5.123,0,0,1-5.121,5.14h-.137",
    transform: "translate(-660.241 -176.913)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M958.69,253.767a6.228,6.228,0,0,1-4.19-1.594l1.287-1.539a4.505,4.505,0,0,0,2.957,1.182c.876,0,1.424-.357,1.424-.935,0-.55-.329-.825-2-1.264-2-.522-3.286-1.072-3.286-3.024,0-1.787,1.424-3,3.45-3A5.575,5.575,0,0,1,962,244.861l-1.177,1.649a4.876,4.876,0,0,0-2.574-.99c-.821,0-1.26.385-1.26.852,0,.66.411.852,2.136,1.292,2,.522,3.122,1.237,3.122,2.969,0,1.979-1.506,3.079-3.614,3.079",
    transform: "translate(-693.136 -176.636)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M992.6,254.024V244.1h7.448v1.952h-5.312v2.007h4.682v1.952h-4.682v2.062h5.394v1.952Z",
    transform: "translate(-720.804 -177.002)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1035.8,247.554c0-.935-.657-1.429-1.7-1.429h-2.163v2.859h2.191c1.068,0,1.67-.577,1.67-1.429m0,6.542-2.108-3.161h-1.7v3.189H1029.8V244.2h4.518c2.355,0,3.724,1.182,3.724,3.271a3.078,3.078,0,0,1-2.136,3.079l2.355,3.546Z",
    transform: "translate(-747.818 -177.074)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1071.29,253.767a6.229,6.229,0,0,1-4.19-1.594l1.287-1.539a4.56,4.56,0,0,0,2.957,1.182c.9,0,1.424-.357,1.424-.935,0-.55-.329-.825-2-1.264-2-.522-3.286-1.072-3.286-3.024,0-1.787,1.424-3,3.45-3a5.574,5.574,0,0,1,3.669,1.264l-1.177,1.649a4.419,4.419,0,0,0-2.519-.99c-.822,0-1.26.385-1.26.852,0,.66.438.852,2.136,1.292,2,.522,3.122,1.237,3.122,2.969,0,1.979-1.506,3.079-3.614,3.079",
    transform: "translate(-774.904 -176.636)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M492.4,318.03a4.946,4.946,0,0,1-5.2-4.7v-.412a5.106,5.106,0,0,1,5.038-5.14h.137a5.345,5.345,0,0,1,3.888,1.374l-1.369,1.649a3.709,3.709,0,0,0-2.574-1.017,3.157,3.157,0,0,0-.137,6.267h.274a3.4,3.4,0,0,0,2.054-.6V314.1H492.32v-1.9h4.3v4.288a6.489,6.489,0,0,1-4.217,1.539",
    transform: "translate(-353.793 -223.168)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M535.472,318.706c-2.656,0-4.272-1.484-4.272-4.4V308.7h2.191v5.608c0,1.594.794,2.446,2.136,2.446s2.136-.8,2.136-2.364V308.7h2.191v5.608c0,3-1.7,4.481-4.326,4.481",
    transform: "translate(-385.745 -223.844)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 2.191,
    height: 9.923,
    transform: "translate(157.065 84.828)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M593.2,318.524V308.6h2.163v7.917h4.929v2.007Z",
    transform: "translate(-430.769 -223.772)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M634.518,313.615a2.851,2.851,0,0,0-2.684-3h-2.026v5.992h1.7a2.839,2.839,0,0,0,2.985-2.639v-.3Zm-2.957,4.948H627.7v-9.9h3.861a4.9,4.9,0,0,1,5.23,4.59v.33a4.965,4.965,0,0,1-4.956,4.975h-.274",
    transform: "translate(-455.822 -223.811)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M966.846,313.415a2.851,2.851,0,0,0-2.683-3h-2v5.992h1.7a2.815,2.815,0,0,0,2.985-2.611v-.385Zm-2.985,4.948H960v-9.9h3.861a4.938,4.938,0,0,1,5.257,4.591v.33a4.959,4.959,0,0,1-4.929,4.975h-.329",
    transform: "translate(-697.13 -223.666)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M695.342,313.415a3.047,3.047,0,0,0-2.9-3.134h-.082a2.945,2.945,0,0,0-2.957,2.941v.137a3.005,3.005,0,0,0,2.9,3.106h.082a2.951,2.951,0,0,0,2.957-2.969Zm-3.039,5.058a5.059,5.059,0,0,1-5.2-4.92v-.137a5.248,5.248,0,0,1,10.487,0,5.134,5.134,0,0,1-5.175,5.058h-.11",
    transform: "translate(-498.956 -223.611)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M737.163,310.579V312.7h4.71v1.979h-4.71v3.848H735V308.6h7.53v1.979Z",
    transform: "translate(-533.74 -223.772)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M832.33,310.866l-1.314,3.216h2.629Zm2.985,7.367-.9-2.254h-4.189l-.9,2.227H827.1l4.244-10.006h2l4.244,10.006Z",
    transform: "translate(-600.621 -223.482)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M880.428,318.524l-4.792-6.322v6.322H873.5V308.6h2l4.628,6.1v-6.1h2.136v9.923Z",
    transform: "translate(-634.316 -223.772) ",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M918.83,310.866l-1.314,3.216h2.629Zm2.985,7.367-.9-2.254h-4.189l-.9,2.227H913.6l4.217-10.006h2.026l4.244,10.006Z",
    transform: "translate(-663.436 -223.482)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1002.5,311.011l-1.314,3.216h2.629Zm2.985,7.367-.9-2.254h-4.189l-.9,2.254H997.3l4.217-9.978h2l4.217,9.978Z",
    transform: "translate(-724.217 -223.627)",
    fill: "rgb(215, 196, 158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M118.237,168.483V138.8h-9.858v-9.9H88.691v9.9H78.834v9.9H68.976v-9.9H49.288v-9.9H29.573v9.9H19.715v9.9H9.858v-9.9H0v49.4H118.237v-9.841h-9.858v-9.9Zm-98.494,9.9H9.885v-9.9h9.858Zm19.688,0H29.6v-9.9h9.858Zm19.715,0h-9.83v-9.9h9.858Zm19.688,0H69v-9.9h9.858Zm19.688,0h-9.83v-9.9h9.858Z",
    transform: "translate(0 -93.468)",
    fill: "rgb(144, 102, 113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M46.03,61.492h0V35.9H44.579V61.492H36.2V71.36h9.83Z",
    transform: "translate(-26.288 -26.032)",
    fill: "rgb(144, 102, 113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M189.858,25.564h-.027V0h-1.424V25.564H180v9.9h9.858Z",
    transform: "translate(-130.712 0)",
    fill: "rgb(144, 102, 113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M261.758,61.464h0V35.9h-1.451V61.464H251.9v9.9h9.858Z",
    transform: "translate(-182.924 -26.032)",
    fill: "rgb(144, 102, 113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M405.658,25.564h0V0h-1.451V25.564H395.8v9.9h9.858Z",
    transform: "translate(-287.421 0)",
    fill: "rgb(144, 102, 113)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScgcLogoBlack);
export default __webpack_public_path__ + "static/media/scgc-logo_black.3529a6dde46a21c5041ce97ed10fb4f6.svg";
export { ForwardRef as ReactComponent };